export const openLinkInNewTab = (link: any) => {
  window.open(link, '_blank');
};
